angular.module("LeasePilot").controller("TopBarController", [
  "$scope",
  "CurrentUserService",
  "UsersService",
  "$rootScope",
  "$mdDialog",
  function($scope, CurrentUserService, UsersService, $rootScope, $mdDialog) {
    $scope.userAction = {};

    $rootScope.user = window.user;
    $rootScope.users = window.users;
    $rootScope.partners = window.partners;
    $rootScope.accounts = window.accounts;
    $rootScope.buildings = window.buildings;

    if ($rootScope.accounts.length > 1) {
      $rootScope.account = $rootScope.accounts.filter(
        acc => acc.id == window.user.company.id
      )[0].id;
    }

    if (window.user.company.companyProfile.config?.warning) {
      $scope.warning = window.user.company.companyProfile.config.warning;

      $scope.showWarning = function() {
        alert(window.user.company.companyProfile.config.warning.message);
      };

      $scope.closeWarning = function() {
        $scope.safeApply(() => {
          $scope.warning = null;
        });
      };
    }

    $scope.selectAccount = function(accountId) {
      // Set cookie server-side to ensure httponly flag is properly set
      $.ajax({
        method: "POST",
        url: "/set_company_id",
        data: { company_id: accountId },
        headers: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
        }
      })
        .done(function() {
          localStorage.removeItem("dashboard_filter");
          window.location.href = "/";
        })
        .fail(function(xhr) {
          console.error("Failed to set company_id cookie:", xhr.responseText);
          // Fallback: try setting cookie client-side (without httponly)
          document.cookie =
            "company_id=" +
            encodeURIComponent(accountId) +
            "; path=/; SameSite=Lax" +
            (window._production ? "; secure" : "");
          localStorage.removeItem("dashboard_filter");
          window.location.href = "/";
        });
    };

    $scope.perform = function() {
      if ($scope.userAction) {
        switch ($scope.userAction) {
          case "Settings":
            window.location.href = "/settings";
            break;

          case "AdminArea":
            window.location.href = "/admin_area";
            break;

          case "SuperAdminArea":
            window.location.href = "/manage/companies";
            break;

          case "Reports":
            window.location.href = "/reports";
            break;

          case "SignOut":
            $.ajax({
              method: "DELETE",
              url: "/users/sign_out"
            }).done(function() {
              window.track.event(new LogoutEvent());
              sessionStorage.clear();
              document.cookie =
                "company_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              window.location.href = "/users/sign_in";
            });
        }

        $scope.userAction = undefined;
      }
    };

    $scope.showCreateVersionDialog = function(event) {
      $mdDialog.show({
        template:
          "<md-dialog><new-version-modal></new-version-modal></md-dialog>",
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: true,
        fullscreen: false
      });
    };
  }
]);
